import firebase from '@/plugins/firebase';

export function httpsImportIiifManifest(payload: {
  projectId: string,
  collectionId: string,
  manifestUrl: string,
}) {
  console.log(arguments);
  const httpsImportIiifManifest = firebase
    .functions()
    .httpsCallable('importIiifManifest');
  return httpsImportIiifManifest(payload);
}
